import type { DocEntityType } from "building-types/doc/docEntityTypes";
import { assert } from "common/utils/assertOfType";
import type { DocTableFieldNames } from "./docTableFieldNames";
import type { DocEntityHandleHash } from "./entity/docEntityHandleHash";
import { isDocEntityHandleHash } from "./entity/docEntityHandleHash";
import { docEntityTableFieldsToEntityType } from "./entity/docEntityTableFieldsToEntityType";
import { docEntityTypeToDocTableName } from "./entity/docEntityTypeToDocTableName";

export function assertIsDocEntityTableField(field: string): asserts field is DocTableFieldNames {
  assert(field in docEntityTableFieldsToEntityType);
}

export function assertIsDocEntityHandleHash(field: string): asserts field is DocEntityHandleHash {
  assert(isDocEntityHandleHash(field));
}

export function getDocTableNamesForEntityTypes<T extends DocEntityType>(
  entityTypes: readonly T[],
): Array<Exclude<(typeof docEntityTypeToDocTableName)[T], undefined>> {
  return entityTypes
    .map((entityType) => docEntityTypeToDocTableName[entityType])
    .filter(
      (tableName): tableName is Exclude<(typeof docEntityTypeToDocTableName)[T], undefined> => tableName !== undefined,
    );
}
